var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductiterationBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.89,238.18c.63-28.63-.65-57-15.71-82.25-23.82-40-66.25-65.74-110.82-76.36-35.09-8.36-71.65,1.69-104.42,14.31-15.53,6-29.45,14.33-46.41,14.45-18.58.14-36.48-6.78-53.46-13.59-42.78-17.15-93-25.62-138.73-14.33-22.71,5.6-45.22,17.16-61.18,35.14-18.63,21-23.45,47.74-29.3,74.32-7.68,34.82-37.61,60.9-56.41,89.73-20.8,31.89-6.91,75,19.89,98.58C171,458,287.44,353,387.5,369.8c51.75,8.72,101.32,28.45,153.79,33.16,30.42,2.73,63.59,2.21,92.77-9.31,18.73-7.38,37.33-19.64,44.25-39.49,6.27-18,.38-36.67-1.39-54.88C675,279.41,676.43,258.72,676.89,238.18Z",
    style: {
      fill: "#1B5E20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.89,238.18c.63-28.63-.65-57-15.71-82.25-23.82-40-66.25-65.74-110.82-76.36-35.09-8.36-71.65,1.69-104.42,14.31-15.53,6-29.45,14.33-46.41,14.45-18.58.14-36.48-6.78-53.46-13.59-42.78-17.15-93-25.62-138.73-14.33-22.71,5.6-45.22,17.16-61.18,35.14-18.63,21-23.45,47.74-29.3,74.32-7.68,34.82-37.61,60.9-56.41,89.73-20.8,31.89-6.91,75,19.89,98.58C171,458,287.44,353,387.5,369.8c51.75,8.72,101.32,28.45,153.79,33.16,30.42,2.73,63.59,2.21,92.77-9.31,18.73-7.38,37.33-19.64,44.25-39.49,6.27-18,.38-36.67-1.39-54.88C675,279.41,676.43,258.72,676.89,238.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-15"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 45.96,
    y1: 237.48,
    x2: 59.95,
    y2: 371.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.7,
    y1: 345.91,
    x2: 51.36,
    y2: 339.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28,341.21a7.2,7.2,0,0,0-2.52-5.38c-1.63-1.45-10.2-5.06-11-2C38.86,337.07,47.63,343.52,53.28,341.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.28,
    y1: 341.21,
    x2: 45.12,
    y2: 336.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.29,
    y1: 361.15,
    x2: 52.95,
    y2: 354.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.87,356.46a7.15,7.15,0,0,0-2.52-5.38c-1.63-1.45-10.2-5.06-11-2C40.45,352.32,49.23,358.77,54.87,356.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.87,
    y1: 356.46,
    x2: 46.72,
    y2: 351.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.82,
    y1: 308.69,
    x2: 47.47,
    y2: 301.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,304a7.19,7.19,0,0,0-2.53-5.38c-1.62-1.45-10.19-5.06-11-2C35,299.86,43.75,306.31,49.4,304Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.4,
    y1: 304,
    x2: 41.24,
    y2: 298.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.41,
    y1: 323.94,
    x2: 49.06,
    y2: 317.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,319.25a7.2,7.2,0,0,0-2.52-5.38c-1.63-1.45-10.2-5.06-11-2C36.57,315.11,45.34,321.56,51,319.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.99,
    y1: 319.25,
    x2: 42.83,
    y2: 314.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.23,
    y1: 283.92,
    x2: 44.89,
    y2: 277.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.81,279.23a7.15,7.15,0,0,0-2.52-5.38c-1.63-1.45-10.2-5.06-11-2C32.39,275.09,41.17,281.54,46.81,279.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.81,
    y1: 279.23,
    x2: 38.66,
    y2: 274.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.63,
    y1: 259.04,
    x2: 42.29,
    y2: 252.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.22,254.35A7.19,7.19,0,0,0,41.69,249c-1.63-1.45-10.19-5.06-11-2C29.8,250.21,38.57,256.66,44.22,254.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.22,
    y1: 254.35,
    x2: 36.06,
    y2: 249.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.63,
    y1: 336.88,
    x2: 61.46,
    y2: 329.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,331.38a7.24,7.24,0,0,1,1.36-5.79c1.3-1.76,8.94-7,10.36-4.27C73.24,324.35,66,332.47,60,331.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.98,
    y1: 331.38,
    x2: 67.33,
    y2: 324.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.44,
    y1: 296.75,
    x2: 57.27,
    y2: 288.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8,291.25a7.17,7.17,0,0,1,1.36-5.78c1.29-1.76,8.93-7.06,10.35-4.28C69.05,284.22,61.8,292.34,55.8,291.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.8,
    y1: 291.25,
    x2: 63.14,
    y2: 284.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.6,
    y1: 279.12,
    x2: 55.43,
    y2: 271.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,273.62a7.19,7.19,0,0,1,1.36-5.79c1.29-1.76,8.93-7.06,10.35-4.27C67.21,266.59,60,274.71,54,273.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.96,
    y1: 273.62,
    x2: 61.3,
    y2: 266.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.91,
    y1: 253.27,
    x2: 52.73,
    y2: 245.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.26,247.76A7.17,7.17,0,0,1,52.62,242c1.29-1.76,8.93-7.06,10.35-4.27C64.51,240.74,57.26,248.85,51.26,247.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.26,
    y1: 247.76,
    x2: 58.6,
    y2: 240.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.84,236.74A7.19,7.19,0,0,1,47.2,231c1.3-1.76,8.94-7,10.36-4.27C59.1,229.71,51.85,237.83,45.84,236.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.84,
    y1: 236.74,
    x2: 53.19,
    y2: 229.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,237a7.15,7.15,0,0,1-5.61-2c-1.62-1.47-6.08-9.62-3.16-10.74C40.67,223.12,48,231.18,46.27,237Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.27,
    y1: 237.04,
    x2: 40.06,
    y2: 229,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.87,
    y1: 255.95,
    x2: 68.95,
    y2: 390.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.03,
    y1: 364.46,
    x2: 67.2,
    y2: 356.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,359a7.19,7.19,0,0,0-1.37-5.78c-1.29-1.76-8.94-7.05-10.35-4.27C55.42,351.94,62.67,360.06,68.68,359Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.68,
    y1: 358.96,
    x2: 61.74,
    y2: 352.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.89,
    y1: 327.25,
    x2: 71.06,
    y2: 319.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54,321.75A7.22,7.22,0,0,0,71.17,316c-1.29-1.75-8.93-7-10.35-4.26C59.28,314.73,66.53,322.85,72.54,321.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.54,
    y1: 321.75,
    x2: 65.6,
    y2: 315.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.31,
    y1: 342.5,
    x2: 69.48,
    y2: 334.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,337a7.19,7.19,0,0,0-1.36-5.79c-1.29-1.75-8.94-7-10.35-4.26C57.7,330,65,338.1,71,337Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.95,
    y1: 337,
    x2: 64.02,
    y2: 330.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.46,
    y1: 302.48,
    x2: 73.63,
    y2: 294.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.11,297a7.17,7.17,0,0,0-1.37-5.79c-1.29-1.76-8.93-7.05-10.35-4.26C61.85,290,69.1,298.07,75.11,297Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.11,
    y1: 296.98,
    x2: 68.17,
    y2: 290.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.04,
    y1: 277.6,
    x2: 76.22,
    y2: 269.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.69,272.1a7.19,7.19,0,0,0-1.36-5.79c-1.3-1.76-8.94-7.05-10.36-4.26C64.43,265.08,71.69,273.19,77.69,272.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.69,
    y1: 272.1,
    x2: 70.75,
    y2: 265.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.85,
    y1: 355.42,
    x2: 79.18,
    y2: 348.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,350.72a7.2,7.2,0,0,1,2.52-5.38c1.63-1.46,10.2-5.07,11-2C91.68,346.57,82.91,353,77.26,350.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.26,
    y1: 350.72,
    x2: 85.89,
    y2: 345.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.01,
    y1: 315.29,
    x2: 83.35,
    y2: 308.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.42,310.59a7.2,7.2,0,0,1,2.52-5.38c1.63-1.46,10.2-5.07,11-2C95.84,306.44,87.07,312.89,81.42,310.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.42,
    y1: 310.59,
    x2: 90.06,
    y2: 305.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.84,
    y1: 297.65,
    x2: 85.18,
    y2: 290.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.25,293a7.2,7.2,0,0,1,2.52-5.38c1.63-1.45,10.2-5.06,11-2.05C97.67,288.81,88.9,295.26,83.25,293Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.25,
    y1: 292.95,
    x2: 91.89,
    y2: 287.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.52,
    y1: 271.8,
    x2: 87.86,
    y2: 265.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.94,267.1a7.15,7.15,0,0,1,2.52-5.38c1.62-1.46,10.19-5.07,11-2.05C100.35,263,91.59,269.4,85.94,267.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.94,
    y1: 267.1,
    x2: 94.57,
    y2: 261.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.91,255.2a7.17,7.17,0,0,1,2.52-5.39c1.63-1.45,10.19-5.06,11-2C97.32,251.05,88.56,257.5,82.91,255.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.91,
    y1: 255.2,
    x2: 91.54,
    y2: 249.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,255.58a7.19,7.19,0,0,1-5.09-3.07c-1.27-1.77-4-10.67-.88-11.17C80.65,240.81,86.14,250.2,83.26,255.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.26,
    y1: 255.58,
    x2: 78.84,
    y2: 246.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.92,
    y1: 201.35,
    x2: 66.92,
    y2: 370.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.06,
    y1: 345.42,
    x2: 61.44,
    y2: 338.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,340.29a7.17,7.17,0,0,0-1.95-5.61c-1.47-1.62-9.62-6.09-10.74-3.18C49.24,334.68,57.3,342,63.15,340.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.15,
    y1: 340.29,
    x2: 55.57,
    y2: 334.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.06,
    y1: 313.55,
    x2: 61.44,
    y2: 306.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,308.42a7.18,7.18,0,0,0-1.95-5.61c-1.47-1.61-9.62-6.09-10.74-3.17C49.24,302.81,57.3,310.13,63.15,308.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.15,
    y1: 308.42,
    x2: 55.57,
    y2: 302.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.06,
    y1: 276.14,
    x2: 61.44,
    y2: 268.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,271a7.17,7.17,0,0,0-1.95-5.61c-1.47-1.62-9.62-6.09-10.74-3.17C49.24,265.4,57.3,272.72,63.15,271Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.15,
    y1: 271.01,
    x2: 55.57,
    y2: 265.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.06,
    y1: 251.23,
    x2: 61.44,
    y2: 243.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,246.11a7.19,7.19,0,0,0-1.95-5.62c-1.47-1.61-9.62-6.09-10.74-3.17C49.24,240.49,57.3,247.82,63.15,246.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.15,
    y1: 246.11,
    x2: 55.57,
    y2: 240.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.06,
    y1: 226.22,
    x2: 61.44,
    y2: 218.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,221.09a7.17,7.17,0,0,0-1.95-5.61c-1.47-1.62-9.62-6.09-10.74-3.17C49.24,215.48,57.3,222.8,63.15,221.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.15,
    y1: 221.09,
    x2: 55.57,
    y2: 215.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.93,
    y1: 355.15,
    x2: 72.55,
    y2: 347.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.84,350a7.17,7.17,0,0,1,2-5.61c1.47-1.62,9.62-6.09,10.74-3.18C84.75,344.41,76.7,351.73,70.84,350Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.84,
    y1: 350.02,
    x2: 78.88,
    y2: 343.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.93,
    y1: 304.47,
    x2: 72.55,
    y2: 297.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.84,299.34a7.17,7.17,0,0,1,2-5.61c1.47-1.62,9.62-6.09,10.74-3.18C84.75,293.73,76.7,301.05,70.84,299.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.84,
    y1: 299.34,
    x2: 78.88,
    y2: 293.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.93,
    y1: 279.45,
    x2: 72.55,
    y2: 272.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.84,274.33a7.19,7.19,0,0,1,2-5.62c1.47-1.61,9.62-6.09,10.74-3.17C84.75,268.71,76.7,276,70.84,274.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.84,
    y1: 274.33,
    x2: 78.88,
    y2: 268.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.93,
    y1: 246.39,
    x2: 72.55,
    y2: 239.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.84,241.26a7.17,7.17,0,0,1,2-5.61c1.47-1.62,9.62-6.09,10.74-3.17C84.75,235.65,76.7,243,70.84,241.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.84,
    y1: 241.26,
    x2: 78.88,
    y2: 235.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.93,
    y1: 220.4,
    x2: 72.55,
    y2: 213.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.84,215.27a7.17,7.17,0,0,1,2-5.61c1.47-1.62,9.62-6.09,10.74-3.18C84.75,209.66,76.7,217,70.84,215.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.84,
    y1: 215.27,
    x2: 78.88,
    y2: 209.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6,203.74a7.17,7.17,0,0,1,2-5.61C70,196.51,78.17,192,79.29,195,80.51,198.13,72.46,205.45,66.6,203.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.6,
    y1: 203.74,
    x2: 74.63,
    y2: 197.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,204.09a7.19,7.19,0,0,1-5.38-2.53c-1.45-1.63-5-10.21-2-11C62.87,189.66,69.3,198.44,67,204.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.99,
    y1: 204.09,
    x2: 61.65,
    y2: 195.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.9 414.89 55.94 414.89 53.7 369.54 76.14 369.54 73.9 414.89",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648.2,
    y: 173.18,
    width: 70.92,
    height: 53.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.19,
    y: 176.6,
    width: 62.96,
    height: 46.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676.58,
    y: 226.76,
    width: 11.66,
    height: 19.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.43,
    y: 246.62,
    width: 41.98,
    height: 43.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.67,
    y: 246.62,
    width: 7.73,
    height: 43.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "682.81 307.05 641 307.05 661.1 290.04 702.91 290.04 682.81 307.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 307.05,
    width: 41.81,
    height: 108.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "703.37 415.74 682.7 415.74 682.7 307.05 703.37 289.55 703.37 415.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.08,165.94l6.36,1.45,1.47-6.45-6.11-1.4c0-.18,0-.36,0-.54a14.46,14.46,0,0,0-1.16-5.71l5-3.95-4.13-5.18-4.74,3.78a14.51,14.51,0,0,0-5.75-3.05v-6.18h-6.62v5.93a14.61,14.61,0,0,0-6,2.7l-4.79-3.82-4.13,5.18,4.68,3.73a14.53,14.53,0,0,0-1.56,6.32l-6.1,1.39,1.48,6.45,6-1.37a14.69,14.69,0,0,0,3.88,5l-2.8,5.81,6,2.87,2.76-5.71a14.32,14.32,0,0,0,6.21.15l2.85,5.92,6-2.87L518,170.65A14.73,14.73,0,0,0,522.08,165.94ZM502.7,159a6.5,6.5,0,1,1,6.5,6.49A6.5,6.5,0,0,1,502.7,159Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,139.84l6.36,1.45,1.47-6.46-6.11-1.39c0-.18,0-.36,0-.55a14.62,14.62,0,0,0-1.16-5.7l5-4-4.13-5.17-4.74,3.78a14.6,14.6,0,0,0-5.75-3.06v-6.17h-6.62v5.93a14.48,14.48,0,0,0-6,2.7l-4.79-3.82-4.13,5.17,4.68,3.73a14.6,14.6,0,0,0-1.56,6.32l-6.1,1.39,1.47,6.46,6-1.37a14.79,14.79,0,0,0,3.87,5L466,150l6,2.87,2.75-5.72a14.47,14.47,0,0,0,3.44.42,14.07,14.07,0,0,0,2.77-.27l2.86,5.93,6-2.88L487,144.55A14.83,14.83,0,0,0,491,139.84Zm-19.38-7a6.5,6.5,0,1,1,6.5,6.5A6.5,6.5,0,0,1,471.65,132.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.83,179l2.8-3.06-3.1-2.84-2.69,2.94-.29-.19a9.23,9.23,0,0,0-3.52-1.15l-.63-4-4.16.66.6,3.8a9.16,9.16,0,0,0-3.49,2.22l-3.41-1.94-2.09,3.66,3.28,1.86a9.3,9.3,0,0,0-.4,4.17l-3.62,1.45,1.57,3.91,3.53-1.41a9.18,9.18,0,0,0,3,2.84l-1.15,3.81,4,1.22,1.13-3.76a9.2,9.2,0,0,0,4-.56l2.33,3.37,3.46-2.39-2.29-3.32a9.59,9.59,0,0,0,1.31-1.76,8.92,8.92,0,0,0,.72-1.62l4.17.28.29-4.2-4-.28A9.4,9.4,0,0,0,251.83,179Zm-9.93,8.52a4.13,4.13,0,1,1,5.63-1.54A4.12,4.12,0,0,1,241.9,187.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,188l2.81-3-3.11-2.85L224.65,185l-.29-.19a9.41,9.41,0,0,0-3.52-1.15l-.63-4-4.15.65.59,3.81a9.24,9.24,0,0,0-3.49,2.22l-3.41-1.95-2.09,3.66,3.28,1.87a9.27,9.27,0,0,0-.4,4.17l-3.62,1.44,1.57,3.91,3.53-1.41a9.32,9.32,0,0,0,3,2.85l-1.15,3.8,4,1.22,1.14-3.76a9.18,9.18,0,0,0,4-.56l2.33,3.38,3.46-2.4-2.29-3.32a9.26,9.26,0,0,0,1.31-1.76,9.72,9.72,0,0,0,.73-1.62l4.17.28L233,192l-4.05-.28A9.29,9.29,0,0,0,227.64,188Zm-9.93,8.53a4.13,4.13,0,1,1,5.64-1.55A4.13,4.13,0,0,1,217.71,196.51Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.19,179,586,176l-3.1-2.84-2.69,2.94-.3-.19a9.19,9.19,0,0,0-3.51-1.15l-.63-4-4.16.66.6,3.8a9.28,9.28,0,0,0-3.5,2.22l-3.41-1.94-2.08,3.66,3.28,1.86a9.3,9.3,0,0,0-.4,4.17l-3.62,1.45,1.56,3.91,3.54-1.41a9.09,9.09,0,0,0,3,2.84l-1.15,3.81,4,1.22,1.13-3.76a9.2,9.2,0,0,0,4-.56l2.33,3.37,3.46-2.39-2.29-3.32a10.06,10.06,0,0,0,1.31-1.76,9.66,9.66,0,0,0,.72-1.62l4.17.28.29-4.2-4.05-.28A9.4,9.4,0,0,0,583.19,179Zm-9.93,8.52a4.12,4.12,0,1,1,5.63-1.54A4.13,4.13,0,0,1,573.26,187.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559,188l2.8-3-3.1-2.85L556,185l-.3-.19a9.3,9.3,0,0,0-3.51-1.15l-.63-4-4.16.65.6,3.81a9.28,9.28,0,0,0-3.5,2.22l-3.41-1.95L539,188.09,542.3,190a9.27,9.27,0,0,0-.4,4.17l-3.62,1.44,1.56,3.91,3.54-1.41a9.32,9.32,0,0,0,3,2.85l-1.15,3.8,4,1.22,1.13-3.76a9.2,9.2,0,0,0,4-.56l2.33,3.38,3.46-2.4-2.29-3.32a9.26,9.26,0,0,0,1.31-1.76,9.66,9.66,0,0,0,.72-1.62l4.17.28.29-4.19-4-.28A9.44,9.44,0,0,0,559,188Zm-9.93,8.53A4.13,4.13,0,1,1,554.7,195,4.14,4.14,0,0,1,549.07,196.51Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.97,
    y1: 133.33,
    x2: 213.64,
    y2: 136.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.56,
    y1: 132.27,
    x2: 237.94,
    y2: 134.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.9,
    cy: 129.69,
    r: 23.48,
    transform: "translate(-10.31 234.49) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,148.2a18.62,18.62,0,1,1,16.47-20.56A18.63,18.63,0,0,1,280,148.2Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.1,
    y: 77.9,
    width: 38.17,
    height: 49.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.15,80.68h0A1.16,1.16,0,0,1,366,79.52V75.17A1.15,1.15,0,0,1,367.15,74h0a1.15,1.15,0,0,1,1.16,1.15v4.35A1.16,1.16,0,0,1,367.15,80.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.84,80.68h0a1.16,1.16,0,0,1-1.16-1.16V75.17A1.15,1.15,0,0,1,375.84,74h0A1.15,1.15,0,0,1,377,75.17v4.35A1.16,1.16,0,0,1,375.84,80.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.53,80.68h0a1.16,1.16,0,0,1-1.16-1.16V75.17A1.15,1.15,0,0,1,384.53,74h0a1.14,1.14,0,0,1,1.15,1.15v4.35A1.15,1.15,0,0,1,384.53,80.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.21,80.68h0a1.16,1.16,0,0,1-1.16-1.16V75.17A1.15,1.15,0,0,1,393.21,74h0a1.15,1.15,0,0,1,1.16,1.15v4.35A1.16,1.16,0,0,1,393.21,80.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.06,
    y1: 91.68,
    x2: 394.15,
    y2: 91.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.06,
    y1: 98.92,
    x2: 394.15,
    y2: 98.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.25,
    y1: 106.16,
    x2: 394.15,
    y2: 106.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.25,
    y1: 113.4,
    x2: 394.15,
    y2: 113.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "365.19 109.34 371.85 115.42 376.78 101.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Machine--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.1,
    y: 282.94,
    width: 417.07,
    height: 23.68,
    rx: 10.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.49,
    y: 286.69,
    width: 408.29,
    height: 16.17,
    rx: 7.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.92,
    cy: 294.69,
    r: 7.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.88,294.69a3,3,0,1,0-3,3A3,3,0,0,0,188.88,294.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.85,
    cy: 294.69,
    r: 7.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,294.69a3,3,0,1,0-3,3A3,3,0,0,0,226.8,294.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.77,
    cy: 294.69,
    r: 7.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.73,294.69a3,3,0,1,0-3,3A3,3,0,0,0,264.73,294.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.7,
    cy: 294.69,
    r: 7.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.66,294.69a3,3,0,1,0-3,3A3,3,0,0,0,302.66,294.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.92,
    cy: 294.69,
    r: 7.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.88,294.69a3,3,0,1,0-3,3A3,3,0,0,0,449.88,294.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484.85,
    cy: 294.69,
    r: 7.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.81,294.69a3,3,0,1,0-3,3A3,3,0,0,0,487.81,294.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.78,
    cy: 294.69,
    r: 7.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.74,294.69a3,3,0,1,0-3,3A3,3,0,0,0,525.74,294.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.71,
    cy: 294.69,
    r: 7.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.66,294.69a3,3,0,1,0-2.95,3A3,3,0,0,0,563.66,294.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.36,306.61a111.21,111.21,0,1,0-211.44,0Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.93,295.64H473.35a20,20,0,0,1,20,20v20.74a0,0,0,0,1,0,0H255.91a0,0,0,0,1,0,0V315.65A20,20,0,0,1,275.93,295.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,330.9H517.27a17.36,17.36,0,0,1,17.36,17.36v67.28a0,0,0,0,1,0,0h-320a0,0,0,0,1,0,0V348.26A17.36,17.36,0,0,1,232,330.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.11,
    y: 341.03,
    width: 9.82,
    height: 10.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.01,
    y: 341.03,
    width: 9.82,
    height: 10.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.58,
    y: 341.03,
    width: 9.82,
    height: 10.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.48,
    y: 341.03,
    width: 9.82,
    height: 10.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.74,
    y1: 362.84,
    x2: 534.57,
    y2: 362.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.02,
    y1: 362.84,
    x2: 254.46,
    y2: 362.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "223.75 414.65 234.11 401.56 315.9 401.56 315.9 415.19",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "525.84 414.65 515.48 401.56 433.69 401.56 433.69 415.19",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.17,389.18c-.82-.77-1.61-1.57-2.35-2.41",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,381.39a35.77,35.77,0,0,1-5.15-18.55h72a36,36,0,0,1-36,36h0a35.8,35.8,0,0,1-19.32-5.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.64,
    cy: 272.05,
    r: 66.54,
    transform: "translate(-38.14 62.33) rotate(-9.05)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.03,
    y1: 301.25,
    x2: 421.4,
    y2: 224.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.58,
    y1: 308.7,
    x2: 341.42,
    y2: 304.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.88,
    y1: 318.39,
    x2: 333.98,
    y2: 312.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.64,
    cy: 272.05,
    r: 22.63,
    transform: "translate(-50.69 89.13) rotate(-12.71)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 719.92,
    y1: 415.54,
    x2: 734,
    y2: 415.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.98,
    y1: 415.54,
    x2: 708.86,
    y2: 415.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.8,253.38,477,238.25l-7.65,2A99.91,99.91,0,0,0,408,177.88l-10.8-12.16-2.8,8.41a99.72,99.72,0,0,0-95.73,33.13l-14.07,5.09,6.29,5.3a99.4,99.4,0,0,0-16.15,54.4h21.14A78.33,78.33,0,0,1,307.2,231.4l6.58,5.54,3.31-18.59a78.56,78.56,0,0,1,70.57-24l-2.52,7.55,17.35-3.56a78.76,78.76,0,0,1,46.32,47.14l-8.76,2.26L466.77,275l5.94-21.33.15,0A2.3,2.3,0,0,1,472.8,253.38Z",
    style: {
      fill: "#1B5E20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.25,258.71c.24-1.84,1.47-2.54,3.29-2.3l6,.78c1.81.24,2.81,1.23,2.57,3.07l-.36,2.78-11.85-1.55Zm10.64,1.41c.12-.94-.41-1.48-1.49-1.62l-6.09-.8c-1.09-.14-1.74.24-1.87,1.21l-.18,1.42,9.44,1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,251l1.17.25-.6,2.85,4.16.87.73-3.51,1.19.25-1,4.81-11.69-2.44,1-4.81,1.18.25-.73,3.5,4,.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.58,243.3l.32.09-.35,1.21-.38-.11c-1-.29-1.75-.07-2,.84s.23,1.49,1.24,1.78c2.57.74,3.93-3,7.16-2.11,1.73.49,2.63,1.66,2.12,3.41s-1.87,2.25-3.61,1.75l-.65-.19.34-1.2.72.21c1,.3,1.76.05,2-.87s-.22-1.52-1.25-1.82c-2.56-.73-3.91,3-7.14,2.11-1.77-.51-2.63-1.65-2.14-3.37S285.85,242.8,287.58,243.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.82,239.69l11.28,3.91-.44,1.25-11.28-3.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,234.11l.95.39-.48,1.17-1-.42c-1-.4-1.76-.25-2.13.65s.07,1.54,1.07,1.94l5.84,2.4c1,.4,1.76.24,2.12-.65s-.07-1.54-1.06-1.94l-2.21-.91-.47,1.14-1.1-.45.94-2.31,3.26,1.33c1.67.69,2.45,1.93,1.75,3.64s-2.12,2-3.79,1.34l-5.72-2.34c-1.67-.69-2.45-1.93-1.76-3.62S289.42,233.43,291.1,234.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.43,235.56l-.53,1.07-10.66-5.39.76-1.51,8.95,1.43-7.7-3.89.53-1.05,10.66,5.38-.63,1.24-10-1.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5,187.45c1.65-.85,2.92-.24,3.77,1.4L338,194.2c.83,1.62.59,3-1.06,3.86l-2.49,1.29L329,188.73Zm4.9,9.55c.85-.44,1-1.18.48-2.15l-2.81-5.46c-.5-1-1.18-1.29-2.05-.85l-1.27.66,4.36,8.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.61,188.63l.47,1.1-2.69,1.13,1.66,3.91,3.29-1.39.48,1.11-4.53,1.92-4.65-11,4.53-1.92.47,1.12-3.3,1.39,1.59,3.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,182.47l5.13,9.24-1.45-10.47,1.16-.39,1.66,12-1.86.62-5.92-10.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.85,184.52l.28,1.16-2.83.7,1,4.13,3.47-.87.29,1.18L352.33,192l-2.88-11.59,4.77-1.18.29,1.18-3.47.86,1,3.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.12,190.61l-2.05-11.76,1.31-.23,1.85,10.57,3.36-.58.2,1.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.56,180.69c-.19-1.82.6-3.08,2.41-3.26s2.85.89,3,2.71l.61,6.15c.18,1.8-.6,3.08-2.43,3.26s-2.84-.92-3-2.72Zm1.93,6.08c.1,1.09.63,1.67,1.58,1.57s1.34-.77,1.23-1.85l-.63-6.28c-.1-1.07-.61-1.68-1.58-1.58s-1.34.79-1.23,1.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.29,177.1c1.87,0,2.7,1.05,2.74,2.85l0,1.44c0,1.89-.82,2.9-2.71,2.94l-1.18,0,.11,4.71-1.33,0-.28-11.94Zm0,6c1,0,1.45-.49,1.43-1.64l0-1.58c0-1.09-.43-1.63-1.41-1.61l-1.27,0,.11,4.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,206.44l6.69-8.4L430,196.67l.76-.94,4.48,3.57-.75.95-1.72-1.38-6.69,8.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,207.11l-.81.88L433,206l-2.88,3.12,2.63,2.43-.82.89-3.61-3.33,8.1-8.77,3.61,3.33-.82.89-2.63-2.43-2.77,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.82,210.74l-.23.23-.87-.92.29-.27c.78-.74,1-1.47.31-2.16s-1.39-.57-2.16.15c-2,1.83.6,4.93-1.86,7.23-1.32,1.24-2.77,1.41-4,.07s-1-2.76.35-4l.5-.47.85.91-.55.51c-.78.74-.94,1.49-.29,2.19s1.42.59,2.2-.14c2-1.82-.6-4.91,1.86-7.21,1.34-1.26,2.76-1.41,4-.11S444.14,209.51,442.82,210.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,219l8.35-6.74-1.38-1.71.94-.76,3.6,4.46-.94.76-1.39-1.71-8.34,6.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,216.48l-9.66,7-.78-1.08,9.66-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.71,225.45l-.64-1,10-6.45.92,1.43-5.78,7,7.27-4.66.63,1-10,6.45-.74-1.17,6.47-7.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,230.54l-.91.48-.59-1.11,1-.52c.95-.5,1.32-1.18.86-2s-1.23-.93-2.18-.42l-5.57,3c-.94.5-1.31,1.2-.85,2s1.23.93,2.17.42l2.11-1.12-.58-1.09,1.05-.56,1.18,2.2-3.1,1.65c-1.59.86-3.05.67-3.92-1s-.21-2.92,1.39-3.77l5.44-2.92c1.6-.85,3.05-.66,3.91.95S457.74,229.69,456.15,230.54Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.57,
    y: 244.3,
    width: 44.65,
    height: 38.87,
    style: {
      fill: "#1B5E20",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.14,
    y: 244.3,
    width: 25.08,
    height: 38.87,
    style: {
      fill: "#1B5E20",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504.74,
    y1: 259.83,
    x2: 510.68,
    y2: 259.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.09,
    y1: 238.77,
    x2: 510.41,
    y2: 241.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 521.21,
    y1: 233.1,
    x2: 523.37,
    y2: 238.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 567.37,
    y1: 259.83,
    x2: 561.43,
    y2: 259.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.02,
    y1: 238.77,
    x2: 561.7,
    y2: 241.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.9,
    y1: 233.1,
    x2: 548.74,
    y2: 238.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.05,
    y1: 238.5,
    x2: 536.05,
    y2: 231.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bulb--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.16,274.81h9.71c3.51-2.95,4.06-9.19,7-12.86h-.09a14.29,14.29,0,1,0-26-8.15c0,3.92,2.1,7.3,4,10.7S209.37,272.44,212.16,274.81Z",
    style: {
      fill: "#1B5E20",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.09,
    y: 275.99,
    width: 9.64,
    height: 2.03,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.09,278.36h9.64a0,0,0,0,1,0,0v.16a1.87,1.87,0,0,1-1.87,1.87H214a1.87,1.87,0,0,1-1.87-1.87v-.16A0,0,0,0,1,212.09,278.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.83,
    y1: 253.99,
    x2: 200.41,
    y2: 253.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.86,
    y1: 238.43,
    x2: 202.44,
    y2: 243,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.72,
    y1: 231.83,
    x2: 211.58,
    y2: 236.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.34,
    y1: 253.99,
    x2: 234.76,
    y2: 253.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.31,
    y1: 238.43,
    x2: 232.73,
    y2: 243,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.45,
    y1: 231.83,
    x2: 223.59,
    y2: 236.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "610.54 291.64 615.6 412.65 624.63 412.65 629.81 315.12 632.34 315.12 641.97 412.65 650.27 412.65 652.44 290.92 610.54 291.64",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.15,
    y: 213.98,
    width: 33.95,
    height: 77.66,
    style: {
      fill: "#1B5E20",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.98 212.69 622.11 339.83 604.36 339.83 604.36 215.02 622.98 212.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.69 255.17 622.98 212.69 619.52 213.12 615.71 226.07 620.65 230.44 616 235.67 622.69 255.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.36,215l-23.28,41.6s-.29,4.66,3.2,6.4,6.11,1.46,7,.88,14-9.9,14-9.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622.69 208.32 622.69 216.18 627.35 223.74 634.91 215.02 634.91 205.71 622.69 208.32",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.79,178.79h6a7.92,7.92,0,0,1,7.92,7.92V201a10.07,10.07,0,0,1-10.07,10.07h-1.68A10.07,10.07,0,0,1,616.87,201V186.71A7.92,7.92,0,0,1,624.79,178.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "622.75 193.97 622.75 201.82 625.76 201.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.78,204.29h4.07a5.2,5.2,0,0,0,3.13-1l.33-.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.45,191.18a2.53,2.53,0,0,1,3.55,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626,191.39a3.86,3.86,0,0,1,4.95,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.71,194.35c0,.92-.34,1.66-.76,1.66s-.75-.74-.75-1.66.34-1.67.75-1.67S620.71,193.43,620.71,194.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.09,194.35c0,.92-.34,1.66-.75,1.66s-.75-.74-.75-1.66.33-1.67.75-1.67S629.09,193.43,629.09,194.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.69,193.05s1.46-4.07,2.91-1.16A8.58,8.58,0,0,1,641,200a1.44,1.44,0,0,1-2.33.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.69,195.83v-8.45a8.58,8.58,0,0,0-8.58-8.59h-4.66a8.54,8.54,0,0,0-6.31,2.79,26.49,26.49,0,0,0,5.88,1.29c2,0,7.85-.59,7.85-.59s-1.74,4.95.29,6.11a12.79,12.79,0,0,0,4.08,1.46v6.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.91,213.27l.87,126h26.48s-2.62-62.26-2.62-63.13-2.91-9-2.91-9l1.16-52.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "637.53 230.44 643.64 226.94 639.86 213.58 634.91 213.27 635.2 255.47 643.35 235.38 637.53 230.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.25,254.88l.88,8.43,40.73,4.37s2-2.91,0-9.6-14-43.36-14-43.36V250.8l1.46,2.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "591.56 237.71 603.49 267.97 628.22 267.97 616.87 237.13 591.56 237.71",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "599.88 237.47 601.52 240.15 609.83 240.14 608.68 237.36 599.88 237.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.25 254.88 625.89 251.09 616.58 250.8 616.58 255.17 622.4 257.79 624.73 260.11 630.84 261.57 630.25 254.88",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "615.48 409.09 601.33 415.54 625.35 415.54 624.55 408.86 615.48 409.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641.12 409.09 626.98 415.54 651 415.54 650.2 408.86 641.12 409.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "159.67 239.99 171.05 260.85 192.18 263.56 192.99 270.06 158.86 270.6 154.25 257.05 159.67 239.99",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.55 342.12 107.11 407.95 114.97 408.22 126.62 343.48 109.55 342.12",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.22 344.56 135.29 407.95 144.5 408.22 149.65 342.39 131.22 344.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.5 408.22 158.86 415.54 134.47 415.54 135.29 407.95 144.5 408.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.32 408.22 130.68 415.54 106.3 415.54 107.11 407.95 116.32 408.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.94,339.68l16.52-.54s-7.86-47.68-7.86-56.89,1.9-29.8,1.9-29.8-9.48,29.26-10,42.8S146.94,339.68,146.94,339.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,217.23s-4.06.81-14.63,13-20,34.68-20.86,42.81-7.86,70.43-7.86,70.43,19.78,2.71,30.62,3.26a112.22,112.22,0,0,0,20.86-1.09S150.46,300.13,151,292s7.31-31.7,8.13-39,3.52-19.78.54-25.47S145,217.23,145,217.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.62,201.39l0-.13c.35-5.91.14-11.39.14-11.39s3.79-1.63,1.08-6.23-8.13-6-15.44-6.51c0,0-12.19,3-13.28,8.4s-.27,23-.27,23l-2.17,8.13,11.11,7.85,3-7s8.67,1.9,12.74-2.71c1-1.14,1.7-3.23,2.2-5.74l2.17-.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.94,200.48c0,1.17-.35,2.12-.79,2.12s-.79-.95-.79-2.12.35-2.13.79-2.13S176.94,199.3,176.94,200.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.71,196.52a3.11,3.11,0,0,1,3.92-.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.36,177.13s-12.19,3-13.28,8.4-.27,23-.27,23l4.07-1.63a16.46,16.46,0,0,1,.81-7.31c1.35-3.79,3-.81,3-.81l1.08,4.33,1.36-.27.27-5.15s2.17-1.08,2.44-2.44-.82-5.41-.82-5.41a31.43,31.43,0,0,0,6.78.54,82.22,82.22,0,0,0,8.94-.54s3.79-1.63,1.08-6.23S172.67,177.68,165.36,177.13Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.21 213.16 165.36 226.17 163.73 232.94 143.14 217.23 147.21 213.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.18 263.56 198.41 259.49 203.29 258.14 203.83 259.22 199.76 261.12 208.7 260.03 208.7 261.12 203.56 263.01 210.6 261.93 210.6 263.83 204.1 264.91 209.79 265.72 209.25 267.35 204.64 267.62 207.35 268.43 206.81 269.51 191.09 270.33 192.18 263.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,230.23s-11.11,2.17-11.11,10.84,19.23,36.3,20,36.57,36.3-6.23,36.3-6.23l-.54-7.85L162.92,263l-9.48-29.26S151.54,230,147.48,230.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.47,209.78s3.28,2.68,6.45,1.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductiterationBro);
export default __webpack_public_path__ + "static/media/Product iteration-bro.eed98d6b66a3861b574d85385481968b.svg";
export { ForwardRef as ReactComponent };